import { useEffect, useState, useMemo } from "react";
// import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import moment from "moment";
// import { useAppDispatch } from "../../../redux/store";
import { LoadingSpinner } from "../../../components/ui/loadinSpinner";
import { getPatientDepartmentData } from "../../../redux/mis/misReducer";
import HorizontalBar from "../../../components/charts/horizontalBar";
import routesName from "../../../constants/routesName";
import { useQueries } from "@tanstack/react-query";
function MADepartment({
    fromDate,
    toDate,
    country,
    state,
    district,
    taluk,
    hobli,
    serviceType,
    filterApplyToggle,
    hospitalArray,
    hospitalId,
    countryid,
    stateid,
    districtid,
    talukid,
    hobliid,
    all,
}: {
    fromDate?: any;
    toDate?: any;
    country?: string;
    state?: string;
    district?: string;
    taluk?: string;
    hobli?: string;
    serviceType?: number;
    hospitalArray?: any;
    filterApplyToggle?: boolean;
    hospitalId?: number;
    countryid?: any;
    stateid?: any;
    districtid?: any;
    talukid?: any;
    hobliid?: any;
    all?: boolean
}) {

    // const dispatch = useAppDispatch();
    const navigate = useNavigate();

    // const departmentsData = useSelector(
    //     (data: any) => data.getPatientDetailsDepartmentsGraphData
    // );

    console.log(country, state, district, taluk, hobli, 3939393)
    const [{ data: departmentsData, isLoading: isgraphLoading }] = useQueries({
        queries: [
            {
                queryKey: ["getEquipmentsListDataService", fromDate, toDate, hospitalId, countryid,
                    stateid,
                    districtid,
                    talukid,
                    hobliid, all],
                queryFn: () => getPatientDepartmentData(fromDate, toDate, hospitalId, countryid,
                    stateid,
                    districtid,
                    talukid,
                    hobliid,
                    all),
            },
        ],
    });

    // console.log(departmentsData, "departmentsData")
    const [, setErrorMessage] = useState<string>("");
    const [departmentsGraphData, setDepartmentsGraphData] = useState<any[]>([]);

    // ✅ Transform API data
    const { labels, values, percentages, totalPatients } = useMemo(() => {
        if (!departmentsGraphData || departmentsGraphData.length === 0) {
            return { labels: [], values: [], percentages: [], totalPatients: 0 };
        }

        // Sort by count DESC
        const sorted = [...departmentsGraphData].sort(
            (a: any, b: any) => b.revenue - a.revenue
        );

        const top5 = sorted.slice(0, 5);
        const others = sorted.slice(5);

        // const othersCountSum = others.reduce(
        //     (acc: number, curr: any) => acc + (curr.count || 0),
        //     0
        // );
        const othersCountSum = others.reduce(
            (acc: number, curr: any) => acc + (curr.revenue || 0),
            0
        );
        const totalPatientsCount = sorted.reduce(
            (acc: number, curr: any) => acc + (curr.count || 0),
            0
        );
        const total = sorted.reduce(
            (acc: number, curr: any) => acc + (curr.revenue || 0),
            0
        );

        const finalData =
            others.length > 0
                ? [
                    ...top5,
                    {
                        description: "Others",
                        count: othersCountSum,
                    },
                ]
                : top5;

        const labels = finalData.map((item: any) => item.description);
        const values = finalData.map((item: any) => item.revenue);
        const percentages = finalData.map((item: any) =>
            total > 0 ? (item.revenue / total) * 100 : 0
        );

        return { labels, values, percentages, totalPatients: totalPatientsCount };
    }, [departmentsGraphData]);

    // Gradient
    const ctx = document.createElement("canvas").getContext("2d");
    const gradient = ctx?.createLinearGradient(0, 0, 200, 0);
    if (gradient) {
        gradient.addColorStop(0, "#FADEB0");
        gradient.addColorStop(1, "#F5B44B");
    }

    const data = {
        labels: labels,
        datasets: [
            {
                label: "value",
                backgroundColor: gradient,
                barPercentage: 0.6,
                borderColor: "#F7C068",
                borderWidth: 1,
                hoverBackgroundColor: gradient,
                hoverBorderColor: "#F7C068",
                data: values,
            },
        ],
    };

    // API response handling
    useEffect(() => {
        if (departmentsData?.status === "success") {
            setErrorMessage("");
            setDepartmentsGraphData(departmentsData?.data?.data ?? []);
        } else if (departmentsData?.status === "failed") {
            setErrorMessage("Something went Wrong");
        }
    }, [departmentsData]);

    // API call
    // useEffect(() => {
    //     dispatch(
    //         getPatientDetailsDepartmentsGraphData({
    //             country: country,
    //             state: state,
    //             district: district,
    //             taluk: taluk,
    //             hobli: hobli,
    //             serviceType: serviceType,
    //             fromDate: moment(fromDate).format("YYYY-MM-DD"),
    //             toDate: moment(toDate).format("YYYY-MM-DD"),
    //             hospitals: [],
    //             hospitalId: hospitalId,
    //         })
    //     );
    // }, [filterApplyToggle, fromDate, toDate]);
    // console.log(departmentsData, "FINAL ARRAY");
    // console.log(data, "332222")
    return (
        <div className={`p-4 bg-white border border-gray-250 shadow-sm1 rounded-lg w-full`} style={{height:!all?"":"90%"}}>
            <div className="w-full flex items-center justify-between pb-2 border-b-[0.5px] border-dashed border-gray-450">
                <span className="text-18 font-medium text-primary">Departments</span>

              {!all&&  <div className="flex items-center gap-2">
                    <div className="border-r-2 border-gray-250">
                        <button
                            type="button"
                            style={{ marginRight: "12px" }}
                            onClick={() => navigate(routesName.misDepartment)}
                        >
                            <span className="text-14 font-[700] text-[#534FA1]">
                                Hospital List
                            </span>
                        </button>
                    </div>

                    <button
                        type="button"
                        onClick={() =>
                            navigate(routesName.MisGraphs, {
                                state: { label: "Departments", hospitalId: hospitalId, singleHospital: true },
                            })
                        }
                    >
                        <span className="text-14 font-[700] text-[#534FA1]">
                            View All
                        </span>
                    </button>
                </div>}
            </div>

            {isgraphLoading ? (
                <div className="flex justify-center items-center h-full">
                    <LoadingSpinner />
                </div>
            ) : departmentsGraphData.length > 0 ? (
                <>
                    <div className="pt-2 flex items-center">
                        <div className="border-r-2 border-gray-250">
                            <span className="text-14 text-secondary">
                                No. of Cases :
                            </span>
                            <span className="text-14 font-[700] text-primary pl-1 pe-2">
                                {departmentsGraphData.length}
                            </span>
                        </div>

                        <span className="text-14 text-secondary ps-3">
                            No. of patients :
                        </span>
                        <span className="text-14 font-[700] text-primary pl-1">
                            {totalPatients.toLocaleString("en-IN")}
                        </span>
                    </div>

                    <div className="h-full pb-14">
                        <HorizontalBar
                            data={data}
                            percentage={percentages}
                            title="Departments"
                        />
                    </div>
                </>
            ) : (
                <div className="flex justify-center items-center h-full">
                    <span className="text-18 font-medium text-primary">
                        No Data Found
                    </span>
                </div>
            )}
        </div>)
}

export default MADepartment